import styled from 'styled-components';

export const StyledJobdomContainer = styled.div`
  position: relative;
  padding-top: 20px;
`;

export const Shadow = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 45px;
  background: linear-gradient(359deg, #ffffff 5.47%, rgba(255, 255, 255, 0) 99.01%);
  border-radius: 4px;

  ${({ theme }) => theme.media.mobile} {
    height: 70px;
  }
`;
